import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowheadDown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		fillRule: "evenodd",
		d: "M10 13a1 1 0 0 1-.8-.4l-3-4A1 1 0 0 1 7 7h6a1 1 0 0 1 .8 1.6l-3 4a1 1 0 0 1-.8.4Z",
		clipRule: "evenodd"
	})]
});
const ForwardRef = forwardRef(SvgArrowheadDown);
export { ForwardRef as ReactComponent };
